<template>
    <div class="component" v-bind:class="classes">
        <v-btn v-bind:color="color"
               v-bind:disabled="disabled || !meetsConditions"
               v-on:click="onClick"
               v-bind:block="displayBlock"
        >{{ label }}
        </v-btn>
        <div class="progress-container" v-if="configShowProgress">
            <v-progress-linear height="2" v-model="progress"></v-progress-linear>
        </div>
    </div>
</template>

<script type="text/babel">
    import {VBtn, VProgressLinear} from 'vuetify/lib'
    import _get from 'lodash/get'

    const CONDITION_IS_FORM_COMPLETED = 'isFormCompleted';

    export default {
        name: 'components-json_page-components-button',
        watch: {
            config() {
                this.clearTimers();
            }
        },
        props: {
            formConditions: {
                default() {
                    return {};
                }
            },
            config: {
                required: true
            },
            disabled: {
                default() {
                    return false;
                }
            }
        },
        data() {
            return {
                progress: 0,
                timeout: undefined,
                progressInterval: undefined
            };
        },
        methods: {
            clearTimers() {
                if (this.timeout) {
                    clearTimeout(this.timeout);
                }

                if (this.progressInterval) {
                    clearInterval(this.progressInterval);
                }
            },
            setTimeout() {
                this.clearTimers();

                let progressStep = Math.ceil(100 / (this.configTimeout / 1000)) / 10;
                this.progress = progressStep;
                this.progressInterval = setInterval(() => {
                    this.progress += progressStep;
                }, 100);

                this.timeout = setTimeout(() => {
                    this.onClick();
                }, this.configTimeout);
            },
            onClick() {
                this.clearTimers();
                this.$emit('click');
            }
        },
        computed: {
            meetsConditions() {
                if (_get(this.formConditions, 'isSubmitting')) {
                    return false;
                }

                let conditions = _get(this.config, 'conditions', []);
                let meetsConditions = true;

                conditions.forEach((condition) => {
                    switch (condition) {
                        case CONDITION_IS_FORM_COMPLETED:
                            if (!_get(this.formConditions, 'isFormCompleted')) {
                                meetsConditions = false;
                            }
                            break;
                    }
                });

                return meetsConditions;
            },
            configShowProgress() {
                return _get(this.config, 'timeout.show_progress') && this.configTimeout > 0;
            },
            configTimeout() {
                return _get(this.config, 'timeout.milliseconds');
            },
            displayBlock() {
                let configValue = _get(this.config, 'block');

                if (configValue === true || configValue === false) {
                    return configValue;
                }

                return this.$mq === 'sm';
            },
            label() {
                return _get(this.config, 'label', '');
            },
            align() {
                return _get(this.config, 'align', 'right');
            },
            color() {
                return _get(this.config, 'color');
            },
            classes() {
                let classes = [];

                if (!this.displayBlock) {
                    switch (this.align) {
                        case 'left':
                            classes.push('float-left');
                            break;
                        case 'right':
                            classes.push('float-right');
                            break;
                    }
                }

                return classes;
            }
        },
        created() {
        },
        mounted() {
            if (this.configTimeout) {
                this.setTimeout();
            }
        },
        beforeDestroy() {
            this.clearTimers();
        },
        mixins: [],
        components: {
            VProgressLinear,
            VBtn
        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .component {
        position: relative;
    }

    .progress-container {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 5px;
        height: 2px;
    }
</style>
